import React, { useEffect, useState } from 'react';
import Filters from 'Src/mentorship/components/mentors/filtersModal';
import { bool, func } from 'prop-types';
import { getFilters } from 'Src/mentorship/actions';
import { Form } from 'antd';
import { forOwn, isEmpty, keys } from 'lodash';

function FiltersModal({ isOpen, toggleModal, getFilteredMentors }) {
  const [filters, setFilters] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    getFilters().then((res) => {
      setFilters(res.data);
    });
  }, []);

  const handleApplyFilterClick = () => {
    const { services, city: _, city_place, ...formFilters } = form.getFieldsValue(true);
    const isFormFiltersPresent = keys(formFilters).length > 0;
    const formFields = [];

    if (isFormFiltersPresent) {
      forOwn(formFilters, (value, key) => {
        if (!isEmpty(value)) {
          formFields.push({
            id: key,
            values: value,
          });
        }
      });
    }

    getFilteredMentors({
      ...(services && { services }),
      ...(!isEmpty(city_place) && { google_place_id: city_place.gpid }),
      ...(isFormFiltersPresent && { form_fields: formFields }),
    });
    toggleModal();
  };

  return (
    <If condition={isOpen}>
      <Filters
        form={form}
        filters={filters}
        isOpen={isOpen}
        toggleModal={toggleModal}
        handleApplyFilterClick={handleApplyFilterClick} />
    </If>
  );
}

FiltersModal.propTypes = {
  isOpen: bool.isRequired,
  toggleModal: func.isRequired,
  getFilteredMentors: func.isRequired,
};

export default FiltersModal;
